export const REVIEW_ADD = "REVIEW_ADD";
export const REVIEW_ADD_SUCCESS = "REVIEW_ADD_SUCCESS";
export const REVIEW_ADD_ERROR = "REVIEW_ADD_ERROR";
export const REVIEW_UPDATE = "REVIEW_UPDATE";
export const REVIEW_UPDATE_SUCCESS = "REVIEW_UPDATE_SUCCESS";
export const REVIEW_UPDATE_ERROR = "REVIEW_UPDATE_ERROR";
export const REVIEW_DELETE = "REVIEW_DELETE";
export const REVIEW_DELETE_SUCCESS = "REVIEW_DELETE_SUCCESS";
export const REVIEW_DELETE_ERROR = "REVIEW_DELETE_ERROR";
export const REVIEW_GET_AUTHOR = "REVIEW_GET_AUTHOR";
export const REVIEW_GET_AUTHOR_SUCCESS = "REVIEW_GET_AUTHOR_SUCCESS";
export const REVIEW_GET_AUTHOR_ERROR = "REVIEW_GET_AUTHOR_ERROR";
export const REVIEW_GET_USER = "REVIEW_GET_USER";
export const REVIEW_GET_USER_SUCCESS = "REVIEW_GET_USER_SUCCESS";
export const REVIEW_GET_USER_ERROR = "REVIEW_GET_USER_ERROR";
export const REVIEW_GET_LIST_ID = "REVIEW_GET_LIST_ID";
export const REVIEW_GET_LIST_ID_SUCCESS = "REVIEW_GET_LIST_ID_SUCCESS";
export const REVIEW_GET_LIST_ID_ERROR = "REVIEW_GET_LIST_ID_ERROR";
